import qs from 'qs';
import { articlesAdapter, articleAdapter } from '@/adapters/articles';

export const useArticlesStore = defineStore({
  id: 'articles',
  actions: {
    fetchArticles({ filter, limit, offset }) {
      const query = qs.stringify(
        { filter, limit, offset },
        { skipNulls: true, addQueryPrefix: true },
      );

      return useRequest(`/articles${query}`).then(articlesAdapter);
    },
    fetchArticle(articleId) {
      return useRequest(`/articles/${articleId}`).then(({ data }) =>
        articleAdapter(data),
      );
    },
  },
});
